import { Button, DialogContent } from '@mui/material';
import { DialogActions, RoutedDialog, RoutedDialogProps } from '@tsp-ui/core/components';
import { capitalize } from '@tsp-ui/core/utils';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import LockAvailabilityButton from './LockAvailabilityButton';
import { LockAvailabilityContent } from './LockAvailabilityContent';
import styles from './LockAvailabilityDialog.module.scss';
import LockAvailabilityForm from './LockAvailabilityForm';
import LockAvailabilityOverrideForm from './LockAvailabilityOverrideForm';
import { LockAvailabilityContext, useLockAvailabilityContextValue } from './LockAvailabilityPage';


enum DialogType {
    ADD = 'ADD',
    EDIT = 'EDIT',
    EDIT_OVERRIDE = 'EDIT_OVERRIDE',
    LIST = 'LIST'
}

const {
    ADD, EDIT, EDIT_OVERRIDE, LIST
} = DialogType;

export function LockAvailabilityDialog(props: Omit<RoutedDialogProps, 'title' | 'children' | 'onSubmit'>) {
    const [ saveLoading, setSaveLoading ] = useState(false);

    const navigate = useNavigate();
    const { day, id, '*': endOfUrl } = useParams();
    const location = useLocation();
    const isGlobal = true;

    const dialogType = endOfUrl === 'add' ? ADD : day ? EDIT : id ? EDIT_OVERRIDE : LIST;

    const dialogTitles = {
        [ADD]: 'Add override',
        [EDIT]: `Edit lock availability - ${capitalize(day || '')}`,
        [EDIT_OVERRIDE]: 'Edit override',
        [LIST]: 'Lock availability'
    };

    const [ lockAvailabilityContextValue, loading ] = useLockAvailabilityContextValue(isGlobal);

    return (
        <LockAvailabilityContext.Provider value={lockAvailabilityContextValue}>
            <RoutedDialog
                title={dialogTitles[dialogType]}
                loading={loading}
                maxWidth={false}
                classes={{
                    paper: dialogType === LIST ? styles.listRoot : undefined
                }}
                {...props}
            >
                <DialogContent>
                    {dialogType === LIST && <LockAvailabilityContent />}

                    {dialogType === EDIT && <LockAvailabilityForm setLoading={setSaveLoading} /> }

                    {(dialogType === EDIT_OVERRIDE || dialogType === ADD) && (
                        <LockAvailabilityOverrideForm setLoading={setSaveLoading} />
                    )}
                </DialogContent>

                <DialogActions loading={saveLoading}>
                    {dialogType === LIST ? <LockAvailabilityButton /> : (
                        <>
                            <Button onClick={() => navigate(location.pathname.replace(/lock-availability.*/, 'lock-availability'))}>
                                Cancel
                            </Button>

                            <Button
                                type="submit"
                                form={
                                    dialogType === EDIT
                                        ? LockAvailabilityForm.formID
                                        : LockAvailabilityOverrideForm.formID
                                }
                                variant="contained"
                            >
                                Save
                            </Button>
                        </>
                    )}
                </DialogActions>
            </RoutedDialog>
        </LockAvailabilityContext.Provider>
    );
}
